var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { Styler, Breadcrumb, BreadcrumbItem, BreadcrumbLink } from '@honeycomb/ui-core';
export function LandingPageBreadcrumb(_a) {
    var { breadcrumbs: { items } } = _a, other = __rest(_a, ["breadcrumbs"]);
    return (React.createElement(Styler, { mt: 5, mb: 4 },
        React.createElement(Breadcrumb, Object.assign({}, other), items === null || items === void 0 ? void 0 : items.map((item, index) => (React.createElement(BreadcrumbItem, { key: `Breadcrumb-${item === null || item === void 0 ? void 0 : item.url}` },
            React.createElement(BreadcrumbLink, { href: item === null || item === void 0 ? void 0 : item.url, active: index === items.length - 1, size: "m" }, item === null || item === void 0 ? void 0 : item.text)))))));
}
